<template>
    <div class="resource_course_wrap">
        <div class="left_box">
            <div class="resource_course_title">{{['', '小班', '中班', '大班'][gradeLevel]}}</div>
            <div class="resource_course_box" :style="`height: ${windowHeight - 140}px;`">
                <el-tree :data="subjectTree" :props="defaultProps" :expand-on-click-node="false" ref="tree"
                         :default-expanded-keys="[showTreeId]" node-key="id" @node-click="handleNodeClick"></el-tree>
            </div>
        </div>
        <div class="right_box">
            <div class="resource_course_list">
                <div class="title_header">
                    {{currentTreeNode.name}}&nbsp;&nbsp;
                    <i class="el-icon-edit" @click.stop="editMenu" v-if="currentTreeNode.type != 1 && currentTreeNode.type != 4"></i>
                    <i class="el-icon-delete" v-if="currentTreeNode.type != 1 && currentTreeNode.type != 4" @click.stop="deleteMenuGuide(true)"></i>
                </div>
                <div class="header">
                    <el-button size="medium" @click="$router.go(-1)">返回</el-button>
                    <el-button size="medium" type="primary" v-if="currentTreeNode.type < 3" @click="addMenu()">新增目录</el-button>
                    <el-button size="medium" type="primary" v-if="currentTreeNode.type == 3" @click="addGuide()">新增指南</el-button>
                </div>
                <div class="table-container" :style="`height: ${windowHeight - 185}px;`">
                    <div v-if="currentTreeNode.type == 3">
                        <el-table
                            :height="windowHeight - 210"
                            :data="currentTreeNode.childrenList"
                            style="width: 100%" border
                        >
                            <el-table-column
                                label="目标"
                                prop="name"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                label="关键点"
                                align="center" show-overflow-tooltip
                                prop="remark"
                            >
                            </el-table-column>
                            <el-table-column
                                label="排序" show-overflow-tooltip
                                align="center"
                                prop="orderNo"
                            >
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                align="center" show-overflow-tooltip
                                prop="type"
                            >
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="editGuide(scope.row)">编辑</el-button>
                                    <el-button size="small" type="text" @click="deleteMenuGuide(false, scope.row.id)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="currentTreeNode.type == 4" class="">

                        {{currentTreeNode.remark}}
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="`${editMenuItem ? '编辑' : '新增'}目录`" :visible.sync="isShowMenuAddEdit" :close-on-press-escape='false'
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div class="change-passbox">
                <el-form :model="menuForm" :rules="menuFormRule" ref="menuForm" status-icon label-width="100px"
                         class="demo-ruleForm">
                    <el-form-item label="名称" prop="name">
                        <el-input type="text" v-model="menuForm.name" auto-complete="off" maxlength="30"
                                  placeholder="请输入名称"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="orderNo">
                        <el-input-number v-model="menuForm.orderNo" :min="1" :max="10000"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowMenuAddEdit = false">取 消</el-button>
                <el-button type="primary" @click="addMenuGuideConfirm(true)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="`${editGuideItem ? '编辑' : '新增'}指南`" :visible.sync="isShowGuideAddEdit" :close-on-press-escape='false'
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div class="change-passbox">
                <el-form :model="guideForm" status-icon ref="guideForm" label-width="100px" :rules="guideFormRule"
                         class="demo-ruleForm">
                    <el-form-item label="名称" prop="name">
                        <el-input type="text" v-model="guideForm.name" auto-complete="off" maxlength="30"
                                  placeholder="请输入名称"></el-input>
                    </el-form-item>
                    <el-form-item label="关键点" prop="remark">
                        <el-input type="textarea" :rows="3" v-model="guideForm.remark" auto-complete="off" maxlength="300"
                                  placeholder="请输入名称"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="orderNo">
                        <el-input-number v-model="guideForm.orderNo" :min="1" :max="10000"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowGuideAddEdit = false">取 消</el-button>
                <el-button type="primary" @click="addMenuGuideConfirm(false)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize';
    import {
        addChildLearnDevelopGuide,
        editChildLearnDevelopGuide,
        findGuideWithChildListByPid,
        deleteChildLearnDevelopGuideById
    } from '@/api/watchingRecords'

    export default {
        name: "resourceCourseIndex",
        data() {
            return {
                rootId: this.$route.query.id,
                gradeLevel: this.$route.query.gradeLevel,
                defaultProps: {
                    children: 'childrenList',
                    label: 'name'
                },
                subjectTree: [],
                currentTreeNode: {},
                isChangeTree: false,

                isShowMenuAddEdit: false,
                menuForm: {
                    name: '',
                    orderNo: 1
                },
                menuFormRule: {
                    name: [
                        {required: true, trigger: 'blur', message: '请输入名称'},
                    ],
                    orderNo: [
                        {required: true, trigger: 'blur', message: '请输入排序'},
                    ],
                },
                isInit: true,
                showTreeId: '',
                editMenuItem: null,

                editGuideItem: null,
                isShowGuideAddEdit: false,
                guideForm: {
                    name: '',
                    remark: '',
                    orderNo: 1
                },
                guideFormRule: {
                    name: [
                        {required: true, trigger: 'blur', message: '请输入名称'},
                    ],
                    orderNo: [
                        {required: true, trigger: 'blur', message: '请输入排序'},
                    ],
                    remark: [
                        {required: true, trigger: 'blur', message: '请输入关键点'},
                    ],
                },
            }
        },
        mixins: [windowResize],
        mounted() {
            this.findGuideWithChildListByPidFunc();
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            handleNodeClick(data) {
                this.showTreeId = data.id;
                this.currentTreeNode = data;
            },
            findGuideWithChildListByPidFunc() {
                findGuideWithChildListByPid({pid: this.rootId, type: 0})
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.subjectTree = pageData;
                        if (pageData.length && this.isInit) {
                            this.currentTreeNode = pageData[0];
                            this.showTreeId = pageData[0].id;
                            this.isInit = false;
                        }
                        setTimeout(() => {
                            this.currentTreeNode = this.$refs.tree.getNode(this.currentTreeNode.id).data;
                        }, 500)
                    })
            },
            changeTreeList(menuName) {
                this.isChangeTree = true;
                this.showTreeDomName = menuName || this.subjectTree[0].name;
                if (!menuName) this.showTreeId = this.subjectTree[0].id;
                this.findGuideWithChildListByPidFunc();
            },
            addMenu() {
                this.editMenuItem = null;
                this.editGuideItem = null;
                this.menuForm = {
                    name: '',
                    orderNo: 1
                };
                this.isShowMenuAddEdit = true;
            },
            addGuide() {
                this.editMenuItem = null;
                this.editGuideItem = null;
                this.guideForm = {
                    name: '',
                    remark: '',
                    orderNo: 1
                };
                this.isShowGuideAddEdit = true;
            },
            editGuide(item) {
                this.editMenuItem = null;
                this.editGuideItem = item;
                this.guideForm.name = item.name;
                this.guideForm.remark = item.remark;
                this.guideForm.orderNo = item.orderNo;
                this.isShowGuideAddEdit = true;
            },
            editMenu() {
                this.editGuideItem = null;
                console.log('this.currentTreeNode', this.currentTreeNode)
                this.editMenuItem = this.currentTreeNode;
                this.menuForm.name = this.editMenuItem.name;
                this.menuForm.orderNo = this.editMenuItem.orderNo;
                this.isShowMenuAddEdit = true;
            },
            addMenuGuideConfirm(isMenu = true) {
                new Promise(resolve => {
                    if(isMenu) {
                        this.$refs.menuForm.validate(isValid => {
                            if(isValid) {
                                resolve()
                            }
                        })
                    } else {
                        this.$refs.guideForm.validate(isValid => {
                            if(isValid) {
                                resolve()
                            }
                        })
                    }
                })
                    .then(() => {
                        const args = {
                            logoUrl: '',
                            name: isMenu ? this.menuForm.name : this.guideForm.name,
                            orderNo: isMenu ? this.menuForm.orderNo : this.guideForm.orderNo,
                            remark: isMenu ? '' : this.guideForm.remark,
                        };

                        if (this.editMenuItem || this.editGuideItem) {
                            args.id = (this.editGuideItem || this.editMenuItem).id;
                        } else {
                            args.gradeLevel = this.gradeLevel;
                            args.level = this.currentTreeNode.level + 1;
                            args.pid = this.currentTreeNode.id;
                            args.type = this.currentTreeNode.type + 1;
                        }
                        new Promise(resolve => {
                            if(this.editMenuItem || this.editGuideItem) {
                                editChildLearnDevelopGuide(args)
                                    .then(res => res.data)
                                    .then(resolve)
                            } else {
                                addChildLearnDevelopGuide(args)
                                    .then(res => res.data)
                                    .then(resolve)

                            }
                        })
                            .then(data => {
                                if (data.result) {
                                    if(isMenu && this.editMenuItem) {
                                        this.editMenuItem.name = this.menuForm.name;
                                        this.editMenuItem.orderNo = this.menuForm.orderNo;
                                    }
                                    this.$message.success(`${this.editMenuItem ? '编辑' : '新增'}成功`);
                                    this.isShowGuideAddEdit = false;
                                    this.isShowMenuAddEdit = false;
                                    this.findGuideWithChildListByPidFunc();

                                }
                            })
                    })


            },
            deleteMenuGuide(isMenu, guideId) {
                this.$confirm(`确认要删除该${isMenu ? '节点' : '目标'}吗？`, "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteChildLearnDevelopGuideById({
                        id: isMenu ? this.currentTreeNode.id : guideId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message.success('删除成功');
                                this.findGuideWithChildListByPidFunc();
                            }
                        })
                });
            }
        }
    }
</script>

<style>
    .resource_course_wrap .el-menu-item {
        height: 36px;
        line-height: 36px;
    }

    .resource_course_wrap .el-menu {
        border-right-width: 0;
    }
</style>
<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_course_wrap {
        height: 100%;
        padding: 12px;
        display: flex;
        box-sizing: border-box;

        .left_box {
            width: 180px;
            height: 100%;
            border-right: 1px solid #eee;
            overflow: hidden;

            .resource_course_title {
                height: 30px;
                line-height: 30px;
                padding-left: 20px;
                font-size: 20px;
                font-weight: bold;
            }

            .resource_course_box {
                @include scrollBar;
            }
        }

        .right_box {
            flex: 1;
            overflow: hidden;
            padding-left: 10px;
        }
        .title_header {
            height: 30px;
            line-height: 30px;
            margin-bottom: 5px;
            font-weight: bold;
        }
        .title_header i {
            margin-left: 6px;
            font-size: 17px;
            font-weight: bold;
            color: #409eff;
            cursor: pointer;
        }
        .title_header .el-icon-delete {
            color: #F56C6C;
        }
    }
    .table-container {
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/watchingRecords/watchingRecordsSettingDetail.vue